import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService, EntityPagedResult, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { Subscription, timer } from 'rxjs';
import { TipoConteudo } from 'src/app/model/arquivo.model';
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';
import { JanelaEnvioProtocolo, ProtocoloArquivo, StatusProtocolo } from 'src/app/model/protocolo-arquivo.model';
import { AmortizacaoEnvio, SolicitacaoHonra, SolicitacaoHonraEnvio, ValorRecebido } from 'src/app/model/solicitacao-honra.model';
import Utils from 'src/app/shared/fgi-utils';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { SolicitacaoHonraService } from '../solicitacao-honra/solicitacao-honra.service';
import { AnoMinimoJuizamentoProcessoValidadtorFn, BN_MASK_NUMERO_PROCESSO } from './AnoMinimoJuizamentoProcessoValidadtorFn';
import { FormatoNumeroProcessoValidadtorFn } from './FormatoNumeroProcessoValidadtorFn';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';
import { MODALIDADE_GARANTIA_FGT, ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { BnMaskPipe } from "@bndes/bndes-ux4/bn-mask/bn-mask-pipe";
import { JanelaSolicitacaoHonraService } from '../janela/janela-solicitacao-honra.service';


class AcaoCRUD {

    public ocorrencias: OcorrenciaValidacaoVO[] = [];
    constructor(
        public label: string,
        public metodoREST: string,
        private modalService: BnModalMessageService,
        private messageService: MessageChannelService,
        private formularioModal: TemplateRef<any>,
        private formularioModalBotoes: TemplateRef<any>,
        public precisaFecharModal: boolean
        ) {
    }

    limpaOcorrencias() {
        this.ocorrencias.length = 0;
    }

    mensagemSucesso() {
        this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: `${this.label} de solicitação de honra realizada com sucesso.`
        });
    }

    mensagemErro() {
        this.messageService.addMessage({
            title: 'Erro',
            type: 'CRUD_OPERATION',
            level: messageLevel.ERROR,
            message: `${this.label} de solicitação de honra nÃ£o foi realizada.`
        });
    }

    executaAcao(ref: SolicitacaoHonraCadastroComponent, callbackSucesso) {
        this.limpaOcorrencias();
        this.modalService
            .abrir(`${this.label} de solicitação de honra`, null, 'lg', this.formularioModal, this.formularioModalBotoes).result
            .then(statusProtocolo => {
                if (statusProtocolo === "SUCESSO") {
                    this.mensagemSucesso();
                    callbackSucesso(ref);
                }
                if (statusProtocolo === "ERRO") {
                    this.mensagemErro();
                }
            }, (reason) => {
                console.debug(`cancelou ${reason}`);
            });
    }
}

@Component({
    selector: 'app-solicitacao-honra-cadastro',
    templateUrl: './solicitacao-honra-cadastro.component.html',
    styleUrls: ['./solicitacao-honra-cadastro.component.scss'],
    standalone: false
})
export class SolicitacaoHonraCadastroComponent extends BaseEntityComponent<SolicitacaoHonra> implements OnInit  {

    private cnpjUsuario: string;
    private janelaEnvioAtual: JanelaEnvioProtocolo = undefined;
    private janelaEnvioAberta: boolean = false;
    private mensagemAlerta: string = undefined;
    private dataAtualBackend: any = undefined;

    private protocoloSHsValidoJanelaAtual: ProtocoloArquivo = undefined;
    private solicitacoesHonra: SolicitacaoHonra[] = [];

    private atributosPaginacaoComponenteListagem: EntityPagedResult<SolicitacaoHonra>;
    private opcoesPaginacao: number[];

    private emProcessamentoLongo: boolean;
    private statusSubscription: Subscription;
    public modalidadeGarantiaDTO: ModalidadeGarantia;

    private INCLUSAO:  AcaoCRUD;
    private ALTERACAO: AcaoCRUD;
    private EXCLUSAO:  AcaoCRUD;
    private EXCLUSAO_TODAS:  AcaoCRUD;
    private acaoCorrente: AcaoCRUD;
    public ocorrenciasPriorizacao: OcorrenciaValidacaoVO[] = [];
    private formulario: UntypedFormGroup;
    private amortizacoesAteADataDaSolicitacaoDeHonra: UntypedFormArray;
    private valoresRecebidos: UntypedFormArray;
    @ViewChild('formularioModal') formularioModal: TemplateRef<any>;
    @ViewChild('formularioModalBotoes') formularioModalBotoes: TemplateRef<any>;

    @ViewChild('prioridadeModal') prioridadeModal: TemplateRef<any>;
    @ViewChild('prioridadeModalBotoes') prioridadeModalBotoes: TemplateRef<any>;
    bnMaskNumeroProcesso: string = BN_MASK_NUMERO_PROCESSO;
    public semAtualizacao: boolean;


    constructor(
        protected injector: Injector,
        private loadingService: BnLoadingService,
        private permissaoService: PermissaoService,
        private modalService: BnModalMessageService,
        private removerAlertasService: RemoverAlertasService,
        private usuarioService: BnUsuarioService,
        protected service: SolicitacaoHonraService,
        private janelaService: JanelaSolicitacaoHonraService,
        private protocoloArquivoService: ProtocoloArquivoService,
        private bnMask: BnMaskPipe,
        private modalidadeGarantiaService: ModalidadeGarantiaService,) {

        super(service, new BaseEntityConfig('/solicitacoes-honra/cadastro'));
        this.config.rotaLista = '/solicitacoes-honra/pesquisa';

        this.opcoesPaginacao = [5, 10, 20];
        this.atributosPaginacaoComponenteListagem = {
          page: 1,
          pageSize: this.opcoesPaginacao[0],
          pages: undefined,
          count: undefined,
          list: undefined
        };
    }

    ngOnInit() {
        this.modalidadeGarantiaService.buscarModalidade().subscribe((resp:any) => {
            this.modalidadeGarantiaDTO = resp;
          });
        this.usuarioService.usuario$.subscribe(usuario => {
            this.cnpjUsuario = usuario.cnpj;
        });
        this.service.getTimeStampISO().subscribe(ts => this.dataAtualBackend = ts);
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.janelaService.getJanelaEnvioDoMesAtual().subscribe(janelaEnvioAtual => {
                if (janelaEnvioAtual) {
                    this.janelaEnvioAtual = janelaEnvioAtual;
                    //console.debug(this.dataAtualBackend);
                    const momentoAtual = moment(this.dataAtualBackend ?
                         Utils.dataFromISO(this.dataAtualBackend.nowDateISO)
                        :Utils.dataCorrente()).startOf('day');
                    if (momentoAtual.isAfter(moment(janelaEnvioAtual.dataFechamento).startOf('day'))) {
                        this.mensagemAlerta = 'A janela de envio de arquivos para o mês atual foi encerrada. Aguardar a' +
                        ' abertura da janela do mês seguinte.';
                    } else  if (momentoAtual.isBefore(moment(janelaEnvioAtual.dataAbertura).startOf('day'))) {
                        this.mensagemAlerta = 'A janela de envio de arquivos para o mês atual ainda não está aberta.';
                    } else {
                        this.formulario = this.createReactiveForm();
                        this.INCLUSAO = new AcaoCRUD ('Inclusão', '',
                            this.modalService, this.messageService,  this.formularioModal, this.formularioModalBotoes, true);
                        this.ALTERACAO = new AcaoCRUD ('Alteração', 'atualiza',
                            this.modalService, this.messageService,  this.formularioModal, this.formularioModalBotoes, true);
                        this.EXCLUSAO = new AcaoCRUD('Exclusão', 'exclui',
                            this.modalService, this.messageService,  this.formularioModal, this.formularioModalBotoes, true);
                        this.EXCLUSAO_TODAS = new AcaoCRUD('Exclusão', 'exclui-todas',
                            this.modalService, this.messageService,  this.formularioModal, this.formularioModalBotoes, false);
                        this.buscarProtocoloSHValidoDaJanelaEnvioAtual();
                        this.janelaEnvioAberta = true;
                    }
                };
            }, error => {
                console.log(error);
            });
        });
    }

    private buscarProtocoloSHValidoDaJanelaEnvioAtual(): void {
        /* preenchimento dos filtros */
        const params: any = {};
        params.cnpjAgente = this.cnpjUsuario;
        params.statusProtocolo = StatusProtocolo.SUCESSO;
        params.dataEnvioInicial = moment(this.janelaEnvioAtual.dataAbertura).format('YYYYMMDD');
        params.dataEnvioFinal = moment(this.janelaEnvioAtual.dataFechamento).format('YYYYMMDD');
        params.apenasValidacao = false;
        params.tiposProtocolos = TipoConteudo.SOLICITACOES_HONRA;

        this.loadingService.bloqueiaTela();

        this.protocoloArquivoService.getArquivoMaisRecente(params)
            .subscribe(response => {

                this.loadingService.liberaTela();

                // no maximo, esperamos um elemento nesta lista (visto que so podemos ter um protocolo com status SUCESSO por janela)
                const protocoloPrevioMesmaJanela: ProtocoloArquivo = response ? response : undefined;
                if (protocoloPrevioMesmaJanela) {
                    this.protocoloSHsValidoJanelaAtual = protocoloPrevioMesmaJanela;
                    const dataEnvio = moment(this.protocoloSHsValidoJanelaAtual.dataEnvio).format('DD/MM/YYYY');
                    const horaEnvio = moment(this.protocoloSHsValidoJanelaAtual.dataEnvio).format('HH:mm');
                    this.mensagemAlerta = 'As ações realizadas por meio desta tela irão modificar o lote enviado ' +
                        `em ${dataEnvio} às ${horaEnvio} (protocolo Id: ${this.protocoloSHsValidoJanelaAtual.idProtocoloNegocio}).`;
                    this.atributosPaginacaoComponenteListagem.page = 1;
                    this.buscarSHsDoProtocoloValido();
                }
        });
    }

    buscarSHsDoProtocoloValido() {
        const params: any = {};
        params.cnpjAgenteFinanceiro = this.cnpjUsuario;
        params.pagina = this.atributosPaginacaoComponenteListagem.page;
        params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

        this.service.getSolicitacoesHonraPorProtocoloNegocio(this.protocoloSHsValidoJanelaAtual.idProtocoloNegocio, params).subscribe(
            response => {
                this.solicitacoesHonra = response.resultados;
                this.atributosPaginacaoComponenteListagem.count = response.totalRegistrosSemPaginacao;
        });
    }

    inclui() {
        this.acaoCorrente = this.INCLUSAO;
        this.removerAlertasService.removerTodos();
        this.formulario.get('sistema').setValue('');
        this.formulario.enable();
        let prioridade = this.solicitacoesHonra.length+1;
        if (this.atributosPaginacaoComponenteListagem
            && this.atributosPaginacaoComponenteListagem.count > 0
            && prioridade < this.atributosPaginacaoComponenteListagem.count+1) {
            prioridade = this.atributosPaginacaoComponenteListagem.count+1;
        }
        this.formulario.reset({sistema: '', prioridade: prioridade});
        this.amortizacoesAteADataDaSolicitacaoDeHonra.clear();
        this.valoresRecebidos.clear();
        this.semAtualizacao = null;
        //this.teste(); // teste
        this.acaoCorrente.executaAcao(this,
            function (objThis: SolicitacaoHonraCadastroComponent) {
                objThis.buscarProtocoloSHValidoDaJanelaEnvioAtual();
            }
        )

        if (!this.utilizaTaxaAtualizacaoGarantia) {
            this.semAtualizacao = true;
        }

        if(this.ehModalidadeFGT){
             this.semAtualizacao = false;
        }
    }

    altera(shPorAlterar: SolicitacaoHonra, ordem: number) {

        this.service.getSolicitacaoHonra(shPorAlterar.id)
            .subscribe(
                shPorAlterarDetalhada => {
                    this.acaoCorrente = this.ALTERACAO;
                    this.preencheFormularioAcao(shPorAlterarDetalhada, ordem);
                    //this.teste(shPorAlterar.id); // teste
                    this.formulario.enable();
                    this.formulario.get('prioridade').disable();
                    this.formulario.get('sistema').disable();
                    this.formulario.get('idOperacaoAgenteCreditoLivre').disable();
                    this.formulario.get('contrato').disable();
                    this.formulario.markAsUntouched();
                    this.formulario.markAsPristine();
                    this.formulario.updateValueAndValidity();
                    this.acaoCorrente.executaAcao(this,
                        function (objThis: SolicitacaoHonraCadastroComponent) {
                            objThis.buscarProtocoloSHValidoDaJanelaEnvioAtual();
                        }
                    )
                }
            );
    }

    exclui (shPorExcluir: SolicitacaoHonra, ordem: number) {
        this.acaoCorrente = this.EXCLUSAO;
        this.removerAlertasService.removerTodos();
        this.service.getSolicitacaoHonra(shPorExcluir.id).subscribe (
            shPorExcluirDetalhada => {
                this.preencheFormularioAcao(shPorExcluirDetalhada, ordem);
                this.formulario.disable();
                this.acaoCorrente.executaAcao( this,
                    function (objThis: SolicitacaoHonraCadastroComponent) {
                        objThis.buscarProtocoloSHValidoDaJanelaEnvioAtual();
                    }
                )
            }
        )
    }

    excluiTodas () {
        this.acaoCorrente = this.EXCLUSAO_TODAS;
        this.removerAlertasService.removerTodos();
        this.confirma();
    }

    get excluindo() {
        return this.acaoCorrente == this.EXCLUSAO;
    }

    get alterando() {
        return this.acaoCorrente == this.ALTERACAO;
    }

    preencheFormularioAcao (shAlvo: SolicitacaoHonra, ordem: number) {
        this.formulario.patchValue({
            prioridade: ordem+1,
            id: shAlvo.id,
            sistema: shAlvo.sistemaRepasse ? shAlvo.sistemaRepasse : 'CL',
            idOperacaoAgenteCreditoLivre: shAlvo.idOperacaoExterno,
            contrato: shAlvo.contratoRepasse,
            valorSaldoDevedorDePrincipal: shAlvo.detalhe ? shAlvo.detalhe.valorSaldoDevedorDePrincipal : null,
            valorSaldoDeJurosNaNormalidade: shAlvo.detalhe ? shAlvo.detalhe.valorSaldoDeJurosNaNormalidade : null,
            valorEncargosMoratorios: shAlvo.detalhe ? shAlvo.detalhe.valorSaldoDeEncargosMoratorios : null,
            possuiBloqueioJudicial: shAlvo.numeroProcesso != null && shAlvo.numeroProcesso !== '',
            numeroProcesso: shAlvo.numeroProcesso,
            dataInicioInadimplencia: shAlvo.dataParcelaInicialInadimplente,
        });
        this.amortizacoesAteADataDaSolicitacaoDeHonra.clear();
        this.valoresRecebidos.clear();
        this.semAtualizacao = true;
        shAlvo.detalhe.recebimentosParciaisDePrincipal
            .forEach(recebimento => {
                console.log(recebimento.dataPrestacao);

                this.adicionarAmortizacaoComValores(
                moment(recebimento.dataPrestacao, 'YYYY-MM-DD').toDate(),
                Number(recebimento.valorDevido),
                Number(recebimento.valorRecebido)
            ) });

        if (this.utilizaTaxaAtualizacaoGarantia) {
            if (shAlvo.detalhe.informeRecebimentosParciaisDePrincipal) {
                shAlvo.detalhe.informeRecebimentosParciaisDePrincipal
                    .forEach(recebimento => {
                        console.log(recebimento.dataPrestacao);
                            this.adicionarValoreAReceberComValores(
                                moment(recebimento.dataPrestacao, 'YYYY-MM-DD').toDate(),
                                Number(recebimento.valorRecebido))
                                this.semAtualizacao = false;

                    });
            }
        }
     }

    confirma() {
        this.acaoCorrente.limpaOcorrencias();
        this.loadingService.bloqueiaTela();

        const operacaoRest = this.acaoCorrente.metodoREST;
        var sh: SolicitacaoHonraEnvio;
        var shId: number;
        if (operacaoRest !== 'exclui-todas') {
            shId = +this.formulario.get('id').value;
            if (operacaoRest !== 'exclui') {
                sh = new SolicitacaoHonraEnvio();
                const sist = this.formulario.get('sistema').value;
                if (sist==='CL') {
                    sh.idOperacaoAgenteCreditoLivre = this.formulario.get('idOperacaoAgenteCreditoLivre').value;
                } else {
                    sh.sistemaRepasse = sist;
                    sh.contratoRepasse = this.formulario.get('contrato').value
                }
                sh.valorSaldoDevedorDePrincipal = +this.formulario.get('valorSaldoDevedorDePrincipal').value;
                sh.valorSaldoDeJurosNaNormalidade = +this.formulario.get('valorSaldoDeJurosNaNormalidade').value;
                sh.valorEncargosMoratorios = +this.formulario.get('valorEncargosMoratorios').value;
                const possuiBloqueio = this.formulario.get('possuiBloqueioJudicial')?.value;
                sh.possuiBloqueioJudicial = possuiBloqueio !== null && possuiBloqueio !== undefined ? String(possuiBloqueio) : null;
                const numeroProcesso = this.formulario.get('numeroProcesso').value;
                if (numeroProcesso) {
                  sh.numeroProcesso = this.bnMask.transform(this.formulario.get('numeroProcesso').value, this.bnMaskNumeroProcesso);
                }
                sh.dataInicioInadimplencia = this.formulario.get('dataInicioInadimplencia').value;

                sh.amortizacoesAteADataDaSolicitacaoDeHonra = this.amortizacoesAteADataDaSolicitacaoDeHonra.controls
                .map ( c => {
                    const amortizacao = new AmortizacaoEnvio();
                    amortizacao.dataVencimento = c.get('dataVencimento').value;
                    amortizacao.valorDevido = +c.get('valorDevido').value;
                    amortizacao.valorRecebido = +c.get('valorRecebido').value;
                    return amortizacao;
                });

                sh.valoresRecebidos = this.valoresRecebidos.controls.map ( c => {
                    const valorRecebido = new ValorRecebido();
                    valorRecebido.dataRecebimento = c.get('dataRecebimento').value;
                    valorRecebido.valorRecebido = +c.get('valorRecebido').value;
                    return valorRecebido;
                });
            }
        }
        this.protocoloArquivoService
            .enviarSHIndividual (operacaoRest,
                this.protocoloSHsValidoJanelaAtual ? this.protocoloSHsValidoJanelaAtual.idProtocoloNegocio : '',
                shId, sh, +this.formulario.get('prioridade').value).subscribe (
            (retorno: unknown) => {
                this.loadingService.liberaTela();
                const msgRetornoProtocolo = (<MensagemRetornoAssincrono> retorno);
                this.iniciaPollingStatus (msgRetornoProtocolo.idProtocolo);
            }, error => {
                console.log(error);
                if (this.protocoloArquivoService.ocorrencias && this.protocoloArquivoService.ocorrencias.length) {
                    this.setOcorrencias(this.protocoloArquivoService.ocorrencias);
                }
                else {
                    this.setOcorrencias([new OcorrenciaValidacaoVO (
                        'Ocorreu um erro inesperado na validação.'
                        , 'E', null, true)]);
                }
                this.loadingService.liberaTela();
            }
        );
    }

    complementaOcorrenciasExclusaoSeNecessario(ocorrencias: OcorrenciaValidacaoVO[]) {
        let temMensagemQuantidadeAmortizacoes = false;
        for (let ocorrencia of ocorrencias) {
            if (ocorrencia.mensagem.startsWith('A quantidade de amortizações informadas (')) {
                temMensagemQuantidadeAmortizacoes = true;
            }
        }
        if (temMensagemQuantidadeAmortizacoes) {
            ocorrencias.push(new OcorrenciaValidacaoVO (
                'É necessário excluir todas as solicitações de honra.'
                , 'E', null, true));
        }
    }

    setOcorrencias(ocorrencias: OcorrenciaValidacaoVO[]) {
        if (this.acaoCorrente) {
            if (this.acaoCorrente == this.EXCLUSAO) {
                this.complementaOcorrenciasExclusaoSeNecessario(ocorrencias);
            }
            this.acaoCorrente.ocorrencias = ocorrencias;
        }
        else {
            this.acaoModalPriorizacao = 'ocorrenciasPriorizacao';
            this.ocorrenciasPriorizacao = ocorrencias;
        }
    }

    iniciaPollingStatus (idProtocolo: string) {
        this.loadingService.bloqueiaTela();
        this.statusSubscription = timer(30000, 30000).subscribe (tentativas => {
            this.emProcessamentoLongo = tentativas >= 3;
            this.protocoloArquivoService.statusSolicitacao(idProtocolo).subscribe (
                status => {
                    // SUCESSO("S", "Validação executada com sucesso."),
                    console.log(`status protocolo ${status}`);
                    if ('SUCESSO' === status) {
                        this.interrompePoolingStatus();
                        if (this.acaoCorrente.precisaFecharModal) {
                            this.modalService.close(status);
                        }
                        else {
                            this.acaoCorrente.mensagemSucesso();
                            this.buscarProtocoloSHValidoDaJanelaEnvioAtual();
                        }
                        return;
                    }
                    // ERRO("E", "Erros encontrados na validação"),
                    if ('ERRO' === status) {
                        // a validação no back terminou com erro
                        this.interrompePoolingStatus();
                        this.protocoloArquivoService.getArquivoResposta(idProtocolo).subscribe (
                            (ocorrenciasValidacao: unknown) => {
                                //console.log(json);
                                this.setOcorrencias(<[OcorrenciaValidacaoVO]>ocorrenciasValidacao);
                            })
                        return;
                    }
                    // SUBSTITUIDO("R", "Substituído");
                    if ('SUBSTITUIDO' === status) {
                        this.interrompePoolingStatus();
                        if (this.acaoCorrente.precisaFecharModal) {
                            this.modalService.close(status);
                        }
                        else {
                            this.buscarProtocoloSHValidoDaJanelaEnvioAtual();
                        }
                        return;
                    }
                    // AGUARDANDO_VALIDACAO("A", "Aguardando validação"),
                    if(this.emProcessamentoLongo) {
                        // o tempo de espera pela validação expirou, mostrando alerta ao usuário
                        this.interrompePoolingStatus();
                        this.setOcorrencias([new OcorrenciaValidacaoVO (
                            ' A validação desta operação está demorando mais do que o esperado. Consulte a tela de envio de arquivos de honra.'
                            , 'E', null, true)]);
                    }
                }, error => {
                    console.log (error);
                    this.interrompePoolingStatus ();
                    if (this.protocoloArquivoService.ocorrencias && this.protocoloArquivoService.ocorrencias.length) {
                        this.setOcorrencias(this.protocoloArquivoService.ocorrencias);
                    }
                    else {
                        this.setOcorrencias([new OcorrenciaValidacaoVO (
                            'Ocorreu um erro inesperado na validação.'
                            , 'E', null, true)]);
                    }
                })
        })
    }

    interrompePoolingStatus(): void {
        this.statusSubscription && this.statusSubscription.unsubscribe();
        this.statusSubscription = null;
        this.loadingService.liberaTela();
    }

    createReactiveForm(): UntypedFormGroup {
        const f =  this.formBuilder.group({
            id:                             [null],
            prioridade:                     [null, [Validators.required, Validators.pattern(/^[0-9]+$/)]],
            sistema:                        ['', Validators.required],
            idOperacaoAgenteCreditoLivre:              [null],
            contrato:                       [null],
            valorSaldoDevedorDePrincipal:   [null, Validators.required],
            valorSaldoDeJurosNaNormalidade: [null, Validators.required],
            valorEncargosMoratorios:        [null, Validators.required],
            possuiBloqueioJudicial:         [false],
            numeroProcesso:                 [null],
            dataInicioInadimplencia:        [null],
        });
        this.amortizacoesAteADataDaSolicitacaoDeHonra = new UntypedFormArray([]);
        this.valoresRecebidos = new UntypedFormArray([]);
        if (this.utilizaTaxaAtualizacaoGarantia) {
          f.get('dataInicioInadimplencia').clearValidators();
          f.get('dataInicioInadimplencia').addValidators(Validators.required);
        }

        f.get('sistema').valueChanges.subscribe((sist) => {
            //console.log(`sistema = ${sist}`);
            const contrato = f.get('contrato');
            const idOperacaoAgenteCreditoLivre = f.get('idOperacaoAgenteCreditoLivre');
            if (!sist) {
                contrato.disable();
                idOperacaoAgenteCreditoLivre.disable();
                return;
            }
            if (sist === 'CL') {
                idOperacaoAgenteCreditoLivre.setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9_\-]+$/),
                    Validators.minLength(1), Validators.maxLength(20)]);
                idOperacaoAgenteCreditoLivre.enable();
                contrato.disable();
                contrato.clearValidators();
            } else {
                contrato.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/),
                    Validators.minLength(11), Validators.maxLength(11)]);
                contrato.enable();
                idOperacaoAgenteCreditoLivre.disable();
                idOperacaoAgenteCreditoLivre.clearValidators();
            }
            contrato.updateValueAndValidity();
            idOperacaoAgenteCreditoLivre.updateValueAndValidity();
        });
        f.get('possuiBloqueioJudicial').valueChanges.subscribe((possuiBloqueioJudicial) => {
          const numeroProcessoField = f.get('numeroProcesso');
          if (possuiBloqueioJudicial) {
            numeroProcessoField.setValidators([
              Validators.required,
              new AnoMinimoJuizamentoProcessoValidadtorFn(this.bnMask).validate(),
              new FormatoNumeroProcessoValidadtorFn(this.bnMask).validate()]);
            numeroProcessoField.enable();
          } else {
            numeroProcessoField.disable();
            numeroProcessoField.clearValidators();
          }
          numeroProcessoField.updateValueAndValidity();
        });
        return f;
    }

    anoAjuizamentoNumeroProcessoInvalido(): boolean {
      return this.formulario.get('numeroProcesso').dirty && this.formulario.get('numeroProcesso').hasError('invalidMinYear');
    }

    formatoNumeroProcessoInvalido(): boolean {
      return this.formulario.get('numeroProcesso').dirty && this.formulario.get('numeroProcesso').hasError('invalidFormat');
    }

    adicionarAmortizacaoComValores(dataVencimento: Date, valorDevido: number, valorRecebido: number) {
        this.amortizacoesAteADataDaSolicitacaoDeHonra.push(
            new UntypedFormGroup ({
                dataVencimento: new UntypedFormControl(dataVencimento, Validators.required),
                valorDevido:    new UntypedFormControl(valorDevido, Validators.required),
                valorRecebido:  new UntypedFormControl(valorRecebido, Validators.required)
            })
        )
    }

    adicionarAmortizacao() {
        this.amortizacoesAteADataDaSolicitacaoDeHonra.push(
            new UntypedFormGroup ({
                dataVencimento: new UntypedFormControl(null, Validators.required),
                valorDevido:    new UntypedFormControl(null, Validators.required),
                valorRecebido:  new UntypedFormControl(null, Validators.required)
            })
        )
    }

    adicionarValoreAReceber() {
        this.valoresRecebidos.push(
            new UntypedFormGroup ({
                dataRecebimento: new UntypedFormControl(null, Validators.required),
                valorRecebido:    new UntypedFormControl(null, Validators.required)
            })
        )
    }

    adicionarValoreAReceberComValores(dataVencimento: Date, valorRecebido: number) {
        this.valoresRecebidos.push(
            new UntypedFormGroup ({
                dataRecebimento: new UntypedFormControl(dataVencimento, Validators.required),
                valorRecebido:  new UntypedFormControl(valorRecebido, Validators.required)
            })
        )
    }

    removerAmortizacao(posicao: number) {
        this.amortizacoesAteADataDaSolicitacaoDeHonra.removeAt(posicao);
    }

    removerValoreAReceber(posicao: number) {
        this.valoresRecebidos.removeAt(posicao);
    }

    mudancaPagina(novaPagina: EntityPagedResult<SolicitacaoHonra>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.buscarSHsDoProtocoloValido();
    }

    voltarParaLista() {
        this.removerAlertasService.removerTodos();
        super.voltarParaLista();
    }

    mesAno(valor?: string): string {
        return Utils.mesAno(valor);
    }

    /*============================*/
    private acaoModalPriorizacao: String = null;
    private inc: number=0;
    obterRepriorizacao() {
        this.ocorrenciasPriorizacao = [];
        this.modalService
            .abrir(`Repriorização das solicitações de honra`, null, 'lg', this.prioridadeModal, this.prioridadeModalBotoes).result
            .then(statusProtocolo => {
                this.acaoModalPriorizacao = null;
                 if (statusProtocolo === "SUCESSO") {
                    this.messageService.addMessage({
                        title: 'Sucesso',
                        type: 'CRUD_OPERATION',
                        level: messageLevel.SUCCESS,
                        message: 'Repriorização realizada com sucesso.'
                    });
                    this.buscarProtocoloSHValidoDaJanelaEnvioAtual()
                }
                if (statusProtocolo === "ERRO") {
                    this.messageService.addMessage({
                        title: 'Erro',
                        type: 'CRUD_OPERATION',
                        level: messageLevel.ERROR,
                        message: 'A repriorização não foi realizada.'
                    });
                }
            }, (reason) => {
                //console.debug(`${JSON.stringify(reason)}`);
                this.acaoModalPriorizacao = null;
            });
    }

    confirmarRepriorizacao () {
        this.acaoModalPriorizacao = 'confirmar' + (this.inc++);  // para forçar o ngOnChanges
    }

    submeterRepriorizacao (_SHsRepriorizadas: SolicitacaoHonra[] ) {

        const _SHsRepriorizadasEnvio: SolicitacaoHonraEnvio[] = _SHsRepriorizadas
            .map( sh => {
                const she = new SolicitacaoHonraEnvio();
                if (sh.contratoRepasse) {
                    she.contratoRepasse = ''+sh.contratoRepasse ;
                    she.sistemaRepasse = sh.sistemaRepasse;
                } else {
                    she.idOperacaoAgenteCreditoLivre = sh.idOperacaoExterno;
                }
                return she
            });
        //console.log(_SHsRepriorizadas);

        this.ocorrenciasPriorizacao = [];

        this.protocoloArquivoService
            .enviarRepriorizacaoSHs (this.protocoloSHsValidoJanelaAtual.idProtocoloNegocio, _SHsRepriorizadasEnvio).subscribe (
            (retorno: unknown) => {
                const msgRetornoProtocolo = (<MensagemRetornoAssincrono> retorno);
                let ocorrencias : OcorrenciaValidacaoVO[] = [];
                this.iniciaPollingStatus (msgRetornoProtocolo.idProtocolo);
                //this.iniciaPollingStatus (this.protocoloSHsValidoJanelaAtual.idProtocoloNegocio);
            }, error => {
                console.log(error);
                //this.ocorrencias = this.protocoloArquivoService.ocorrencias;
            }
        );
    }

    teste(idSh?: number) {
        this.formulario.reset({
            prioridade: this.solicitacoesHonra.length+1
            , id: idSh
            , sistema:'CL'
            , idOperacaoAgenteCreditoLivre: 'OPE-124'
            , sistemaRepasse: null
            , valorSaldoDevedorDePrincipal: 10000.00
            , valorSaldoDeJurosNaNormalidade: 0
            , valorEncargosMoratorios: 0
            , dataInicioInadimplencia: null});
        let deslocamento=-10;
        for (let i=0; i< 5; i++) {
            deslocamento++;
            const amortizacao = new UntypedFormGroup ({
                dataVencimento: new UntypedFormControl(
                    moment(new Date()).date(15).add(moment.duration(deslocamento, 'months')).startOf('day') .toDate(), Validators.required),
                valorDevido: new UntypedFormControl(10000, Validators.required),
                valorRecebido: new UntypedFormControl(i<4? 10000: 1000, Validators.required)
            });
            this.amortizacoesAteADataDaSolicitacaoDeHonra.push(amortizacao);
        }
    }

    podeMostrarConfirmar() {
        return !(this.acaoCorrente.ocorrencias && this.acaoCorrente.ocorrencias.length)
            || ((this.acaoCorrente == this.INCLUSAO || this.acaoCorrente == this.ALTERACAO) && !this.existeOcorrenciaQueImpedeConfirmacao());
    }

    private existeOcorrenciaQueImpedeConfirmacao() {
        for (let ocorrencia of this.acaoCorrente.ocorrencias) {
            if (ocorrencia.impedeConfirmacao) {
                return true;
            }
        }
        return false;
    }

    validarOpcaoAtualizacao(valorOpcao) {
        if (valorOpcao === 'semAtualizacao') {
          this.semAtualizacao = true;
          this.formulario.get('dataInicioInadimplencia').disable();
        }
        else {
          this.semAtualizacao = false;
          this.formulario.get('dataInicioInadimplencia').enable();
        }
    }

    get utilizaTaxaAtualizacaoGarantia() {
        return this.modalidadeGarantiaDTO.utilizaTaxaAtualizacaoGarantia;
    }

    get ehModalidadeFGT() {
        return this.modalidadeGarantiaDTO.sigla === MODALIDADE_GARANTIA_FGT;
    }

    formatarMensagem(mensagemErro: string): string{
        const idOperacao = this.formulario?.get('idOperacaoAgenteCreditoLivre')?.value || '';
        return mensagemErro?.replace(/ID_OPERACAO_AGENTE/gi, idOperacao) || mensagemErro;
    }
}

